<template>
 <div class="product-system-item animate__animated  animate__slideInRight ">
  <div class="product-system-item-left">
   <div class="product-system-item-left-title">{{ _info.input988275a1 }}</div>
   <div class="product-system-item-left-content">
    <div class="product-system-item-left-content-left">
     <div class="product-system-item-left-content-left-top"></div>
     <div class="product-system-item-left-content-left-con"></div>
     <div class="product-system-item-left-content-left-top"></div>
    </div>
    <div class="product-system-item-left-content-right">
     {{ _info.inputde060c84 }}
    </div>
   </div>
   <div>
    <div class="product-system-item-left-content-left-learnmore">
     <learnmore path="/product"></learnmore>
    </div>

   </div>

  </div>
  <div class="product-system-item-right">
   <div class="product-system-item-right-img-box">
    <img :src="getImgUrl(_info)" alt="" class="product-system-item-right-img">
   </div>
  </div>
 </div>
</template>

<script setup>
import learnmore from "@/components/learnmore.vue"
import { computed } from 'vue'

const props = defineProps({
 item: {
  type: Object,
  default: () => ({})
 }
})

const _info = computed(() => props.item)
const getImgUrl = (item) => {
 if (item['picture-uploadc8da899c'] && item['picture-uploadc8da899c'].length > 0) {
  return item['picture-uploadc8da899c'][0].url
 } else {
  return ""

 }
}

</script>

<style scoped lang="less">
.product-system-item {
 width: 100%;
 height: 100%;
 display: flex;
}

.product-system-item-left {
 width: 40%;
 height: 100%;
 padding: 85px 20px 0 110px;
}

.product-system-item-right {
 width: 60%;
 height: 100%;
}

.product-system-item-left-title {
 color: #2081EB;
 font-size: 30px;
 overflow: hidden;
 text-overflow: ellipsis;
 white-space: nowrap;
}

.product-system-item-left-content {
 display: flex;
 margin-top: 50px;
}

.product-system-item-left-content-left {
 display: flex;
 flex-direction: column;
 align-items: center;
 height: 200px;
 width: 15px;

}

.product-system-item-left-content-left-con {
 width: 2px;
 height: 180px;
 background-color: #2081EB;
}

.product-system-item-left-content-left-top {
 width: 12px;
 height: 12px;
 background-color: #2081EB;
 border-radius: 50%;
}

.product-system-item-left-content-right {
 width: 100%;
 height: 200px;
 padding-right: 110px;
 padding-left: 15px;
}

.product-system-item-left-content-left-learnmore {
 // margin-top: 100px;
 margin-right: 230px;
}

.product-system-item-right-img-box {
 width: 794px;
 height: 87%;
 margin-top: 34px;
 border-radius: 10px;
 overflow: hidden;
}

.product-system-item-right-img {
 width: 100%;
 // height: 100%;
}
</style>